// // =============================================
// // File: src/services/orderService.js
// // =============================================

// import axiosInstance from "./axiosConfig";

// const orderService = {
//   // Get all orders with pagination and filters
//   createRazorpayOrder: async (data) => {
//     try {
//       const response = await axiosInstance.post(
//         "/orders/razorpay/create-order",
//         data
//       );
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Verify Razorpay payment
//   verifyRazorpayPayment: async (data) => {
//     try {
//       const response = await axiosInstance.post(
//         "/orders/razorpay/verify-payment",
//         data
//       );
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Validate discount
//   validateDiscount: async (data) => {
//     try {
//       const response = await axiosInstance.post(
//         "/orders/validate-discount",
//         data
//       );
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Create order
//   createOrder: async (data) => {
//     try {
//       const response = await axiosInstance.post("/orders", data);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Get customer orders
//   getCustomerOrders: async (params = {}) => {
//     try {
//       const response = await axiosInstance.get("/orders/my-orders", { params });
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
//   getOrders: async (params = {}) => {
//     try {
//       const response = await axiosInstance.get("/orders", { params });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Get single order by ID
//   getOrderById: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/orders/${id}`);
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Create new order
//   createOrder: async (orderData) => {
//     try {
//       const response = await axiosInstance.post("/orders", orderData);
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Update order
//   updateOrder: async (id, orderData) => {
//     try {
//       const response = await axiosInstance.put(`/orders/${id}`, orderData);
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Update order status
//   updateOrderStatus: async (id, status) => {
//     try {
//       const response = await axiosInstance.patch(`/orders/${id}/status`, {
//         status,
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Update shipping details
//   updateShippingDetails: async (id, shippingData) => {
//     try {
//       const response = await axiosInstance.patch(
//         `/orders/${id}/shipping`,
//         shippingData
//       );
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Cancel order
//   cancelOrder: async (id, reason) => {
//     try {
//       const response = await axiosInstance.post(`/orders/${id}/cancel`, {
//         reason,
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Get order tracking
//   getOrderTracking: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/orders/${id}/tracking`);
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Process payment for order
//   processPayment: async (id, paymentData) => {
//     try {
//       const response = await axiosInstance.post(
//         `/orders/${id}/payment`,
//         paymentData
//       );
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Generate invoice
//   generateInvoice: async (id) => {
//     try {
//       const response = await axiosInstance.get(`/orders/${id}/invoice`, {
//         responseType: "blob",
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Get order history for customer
//   getCustomerOrders: async (customerId, params = {}) => {
//     try {
//       const response = await axiosInstance.get(`/orders/my-orders`, { params });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },

//   // Bulk update order status
//   bulkUpdateStatus: async (orderIds, status) => {
//     try {
//       const response = await axiosInstance.post("/orders/bulk-status", {
//         orderIds,
//         status,
//       });
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   },
// };

// export default orderService;

// =============================================
// File: src/services/orderService.js
// =============================================

import axiosInstance from "./axiosConfig";

const orderService = {
  // ==================== RAZORPAY ====================

  // Create Razorpay order
  createRazorpayOrder: async (data) => {
    try {
      const response = await axiosInstance.post(
        "/orders/razorpay/create-order",
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify Razorpay payment
  verifyRazorpayPayment: async (data) => {
    try {
      const response = await axiosInstance.post(
        "/orders/razorpay/verify-payment",
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ==================== DISCOUNT ====================

  // Validate discount
  validateDiscount: async (data) => {
    try {
      const response = await axiosInstance.post(
        "/orders/validate-discount",
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ==================== ORDERS - ADMIN ====================

  // Get all orders (Admin)
  getOrders: async (params = {}) => {
    try {
      const response = await axiosInstance.get("/orders", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single order by ID
  getOrderById: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update order status (Admin)
  updateOrderStatus: async (id, statusData) => {
    try {
      const response = await axiosInstance.patch(
        `/orders/${id}/status`,
        statusData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update shipping details (Admin)
  updateShippingDetails: async (id, shippingData) => {
    try {
      const response = await axiosInstance.patch(
        `/orders/${id}/shipping`,
        shippingData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Bulk update order status (Admin)
  bulkUpdateStatus: async (orderIds, status) => {
    try {
      const response = await axiosInstance.post("/orders/bulk-status", {
        orderIds,
        status,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ==================== ORDERS - CUSTOMER ====================

  // Create new order
  createOrder: async (orderData) => {
    try {
      const response = await axiosInstance.post("/orders", orderData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get customer's own orders
  getCustomerOrders: async (params = {}) => {
    try {
      const response = await axiosInstance.get("/orders/my-orders", { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cancel order
  cancelOrder: async (id, reason) => {
    try {
      const response = await axiosInstance.post(`/orders/${id}/cancel`, {
        reason,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get order tracking
  getOrderTracking: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}/tracking`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ==================== PAYMENT ====================

  // Process payment for order
  processPayment: async (id, paymentData) => {
    try {
      const response = await axiosInstance.post(
        `/orders/${id}/payment`,
        paymentData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ==================== INVOICE ====================

  // Generate invoice
  generateInvoice: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}/invoice`, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default orderService;
